module.exports = __webpack_public_path__ + "img/SearchIcon.76fb06f0.svg";